import { LocalStorageKeys } from "../Components/QuoteRequest/Content";
import { isJsonString } from "./Helper";

export const getCurrentOpportunityDataFromSession = () => {
    let opportunityObj = null;
    opportunityObj = isJsonString(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
        ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
        : null;
    return opportunityObj;
};

export const SetCRMDataInSession = (data, opportunityId) => {
    if (
        (!sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) &&
            (sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) ==
                null ||
                sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) ==
                "null")) ||
        sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) ==
        undefined ||
        sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) ==
        "undefined" ||
        (isJsonString(
            sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)
        ) &&
            JSON.parse(
                sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)
        )?.opportunityId != opportunityId)
    ) {
        const jsonCRMData = JSON.stringify(data);
        sessionStorage.setItem(
            LocalStorageKeys.CRMDATAINITIAL,
            jsonCRMData
        );
    }
};

export const SetLoggedInUserDataInSession = (data) => {
    if (
        (!sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER) &&
            (sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER) == null ||
                sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER) ==
                "null")) ||
        (isJsonString(
            sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
        ) &&
            JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
                ?.user?.id != data?.user?.id)
    ) {
        const jsonUserData = JSON.stringify(data);
        sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
    }
};